import { Level } from '@enums/level.enum';
import { HttpHelper } from '@helpers/http.helper';

export interface AntiMoneyLaunderingJson {
  id: number;
  ape: string;
  identity_conclusion: string;
  identity_risk: Level;
  shareholding_conclusion: string;
  shareholding_risk: Level;
  operations_conclusion: string;
  operations_risk: Level;
  global_conclusion: string;
  global_risk: Level;
  entity_identification_documentation: boolean;
  high_risk_activity_sector: boolean;
  frequent_legal_changes: boolean;
  effective_beneficiary_identified: boolean;
  effective_beneficiary_identity_piece: boolean;
  directors_politically_exposed: boolean;
  directors_integrity_doubts: boolean;
  period_operations_consistent: boolean;
  complex_operations: boolean;
  irregular_high_amounts: boolean;
  operations_without_economic_proofs: boolean;
  funds_origins_justified: boolean;
  risked_transactions: boolean;
  representant_identification_valid: boolean;
}

export class AntiMoneyLaundering {
  constructor(
    public id?: number,
    public ape?: string,
    public identityConclusion?: string,
    public identityRisk?: Level,
    public shareholdingConclusion?: string,
    public shareholdingRisk?: Level,
    public operationsConclusion?: string,
    public operationsRisk?: Level,
    public globalConclusion?: string,
    public globalRisk?: Level,
    public entityIdentificationDocumentation?: boolean,
    public highRiskActivitySector?: boolean,
    public frequentLegalChanges?: boolean,
    public effectiveBeneficiaryIdentified?: boolean,
    public effectiveBeneficiaryIdentityPiece?: boolean,
    public directorsPoliticallyExposed?: boolean,
    public directorsIntegrityDoubts?: boolean,
    public periodOperationsConsistent?: boolean,
    public complexOperations?: boolean,
    public irregularHighAmounts?: boolean,
    public operationsWithoutEconomicProofs?: boolean,
    public fundsOriginsJustified?: boolean,
    public riskedTransactions?: boolean,
    public representantIdentificationValid?: boolean
  ) {}

  static fromJson(json: Partial<AntiMoneyLaunderingJson>): AntiMoneyLaundering {
    return new AntiMoneyLaundering(
      json.id,
      json.ape,
      json.identity_conclusion,
      json.identity_risk,
      json.shareholding_conclusion,
      json.shareholding_risk,
      json.operations_conclusion,
      json.operations_risk,
      json.global_conclusion,
      json.global_risk,
      json.entity_identification_documentation,
      json.high_risk_activity_sector,
      json.frequent_legal_changes,
      json.effective_beneficiary_identified,
      json.effective_beneficiary_identity_piece,
      json.directors_politically_exposed,
      json.directors_integrity_doubts,
      json.period_operations_consistent,
      json.complex_operations,
      json.irregular_high_amounts,
      json.operations_without_economic_proofs,
      json.funds_origins_justified,
      json.risked_transactions,
      json.representant_identification_valid
    );
  }

  static toJson(antiMoneyLaundering: AntiMoneyLaundering): AntiMoneyLaunderingJson {
    return {
      id: HttpHelper.toJsonProperty(antiMoneyLaundering.id),
      ape: HttpHelper.toJsonProperty(antiMoneyLaundering.ape),
      identity_conclusion: HttpHelper.toJsonProperty(antiMoneyLaundering.identityConclusion),
      identity_risk: HttpHelper.toJsonProperty(antiMoneyLaundering.identityRisk),
      shareholding_conclusion: HttpHelper.toJsonProperty(antiMoneyLaundering.shareholdingConclusion),
      shareholding_risk: HttpHelper.toJsonProperty(antiMoneyLaundering.shareholdingRisk),
      operations_conclusion: HttpHelper.toJsonProperty(antiMoneyLaundering.operationsConclusion),
      operations_risk: HttpHelper.toJsonProperty(antiMoneyLaundering.operationsRisk),
      global_conclusion: HttpHelper.toJsonProperty(antiMoneyLaundering.globalConclusion),
      global_risk: HttpHelper.toJsonProperty(antiMoneyLaundering.globalRisk),
      entity_identification_documentation: HttpHelper.toJsonProperty(
        antiMoneyLaundering.entityIdentificationDocumentation
      ),
      high_risk_activity_sector: HttpHelper.toJsonProperty(antiMoneyLaundering.highRiskActivitySector),
      frequent_legal_changes: HttpHelper.toJsonProperty(antiMoneyLaundering.frequentLegalChanges),
      effective_beneficiary_identified: HttpHelper.toJsonProperty(antiMoneyLaundering.effectiveBeneficiaryIdentified),
      effective_beneficiary_identity_piece: HttpHelper.toJsonProperty(
        antiMoneyLaundering.effectiveBeneficiaryIdentityPiece
      ),
      directors_politically_exposed: HttpHelper.toJsonProperty(antiMoneyLaundering.directorsPoliticallyExposed),
      directors_integrity_doubts: HttpHelper.toJsonProperty(antiMoneyLaundering.directorsIntegrityDoubts),
      period_operations_consistent: HttpHelper.toJsonProperty(antiMoneyLaundering.periodOperationsConsistent),
      complex_operations: HttpHelper.toJsonProperty(antiMoneyLaundering.complexOperations),
      irregular_high_amounts: HttpHelper.toJsonProperty(antiMoneyLaundering.irregularHighAmounts),
      operations_without_economic_proofs: HttpHelper.toJsonProperty(
        antiMoneyLaundering.operationsWithoutEconomicProofs
      ),
      funds_origins_justified: HttpHelper.toJsonProperty(antiMoneyLaundering.fundsOriginsJustified),
      risked_transactions: HttpHelper.toJsonProperty(antiMoneyLaundering.riskedTransactions),
      representant_identification_valid: HttpHelper.toJsonProperty(antiMoneyLaundering.representantIdentificationValid)
    };
  }
}
